import { Outlet } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Toaster } from '@/components/ui/toast';
import { usePageTitle } from './usePageTitle';

export function RootLayout() {
  const title = usePageTitle();
  useEffect(() => {
    document.title = title === 'Lemon AI' ? title : `${title} · Lemon AI`;
  }, [title]);
  return (
    <>
      <Outlet />
      <Toaster />
    </>
  );
}

/** Signed-out and standalone screens: no sidebar. */
export function FullscreenLayout() {
  return <Outlet />;
}
